<template>

  <q-toolbar class="bg-grey-2">
    <q-toolbar-title class="text-100 text-bold">Plan Details</q-toolbar-title>
  </q-toolbar>

  <q-card flat class="q-mb-md">

    <q-card-section horizontal class="justify-start item-start flex">
      <q-btn flat no-caps :href="plan.document_links.find(x=> x.type === 'efl').link" target="_blank">
        <template v-slot:default>
          <q-icon name="description" class="q-mr-sm"></q-icon>
          <div class="text-blue-grey-8">Facts Label</div>
        </template>
      </q-btn>
      <q-btn flat no-caps :href="plan.document_links.find(x=> x.type === 'tos').link" target="_blank">
        <template v-slot:default>
          <q-icon name="description" class="q-mr-sm"></q-icon>
          <div class="text-blue-grey-8">Terms of Service</div>
        </template>
      </q-btn>
      <q-btn flat no-caps :href="plan.document_links.find(x=> x.type === 'yraac').link" target="_blank">
        <template v-slot:default>
          <q-icon name="description" class="q-mr-sm"></q-icon>
          <div class="text-blue-grey-8">YRAC</div>
        </template>
      </q-btn>
    </q-card-section>

    <q-card-section class="q-mt-sm q-mb-sm">
      <div>


        <div v-if="plan.product.early_termination_fee_pro_rated">
          <q-icon name="info" size="sm" class="q-mr-sm"></q-icon>
          <span class="text-blue-grey-8">
            Early Termination Fee: ${{ plan.product.early_termination_fee / plan.product.term }} per month
          </span>
        </div>
        <div v-else>
          <q-icon name="info" size="sm" class="q-mr-sm"></q-icon>
          <span class="text-blue-grey-8">Early Termination Fee: ${{ plan.product.early_termination_fee }}</span>
        </div>

        <p class="text-blue-grey-8" style="margin-left: 30px">
          (Note: This fee will not be charged if you end your contract early because you are moving out)
        </p>

        <q-separator></q-separator>

        <div class="text-100 text-bold q-py-md">
          {{ plan.product.description }}
        </div>

        <div class="text-positive text-100 text-bold">
          <q-icon name="check_box" size="sm" class="q-mr-md"></q-icon>
          No hidden fees. The rates shown below already include all fees, discounts, and {{ plan.tdsp.short_name }}
          delivery charges.
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  name: "PlanDetails",
  props: {
    plan: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>

</style>
